// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1MNgv","signatureBlock":"Footer_signatureBlock__3Ek1P","signature":"Footer_signature__3IMYW"};